import React, { useEffect, useRef, useState } from "react";
import styles from "./about.module.scss";
import Details from "../details/Details";
import { detailsData } from "../../data";

const AboutUs = () => {
  const MyRef = useRef(null);
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setVisible(entry.isIntersecting);
        console.log(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    if (MyRef.current) {
      observer.observe(MyRef.current);
    }

    return () => {
      if (MyRef.current) observer.unobserve(MyRef.current);
    };
  }, [MyRef, visible]);

  return (
    <div className={styles.container} ref={MyRef} id="about">
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <h3 className={styles.smallHeading}>--Megam--</h3>
          <h2 className={styles.heading}>Cloud Service provider</h2>
        </div>
        <div className={visible ? styles.left : styles.leftEvent}>
          <img
            src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/ABOUT_US/aboutUsImage.png"
            alt="About Us"
          />
        </div>
        <div className={styles.right}>
          <div className={styles.rightTop}>
            <h4 className={styles.smallHeading}>--Megam--</h4>
            <h3 className={styles.heading}>Cloud Service provider</h3>
          </div>
          <div className={visible ? styles.rightBottomEvent : styles.rightBottom} >
            {detailsData.map((item) => (
              <Details ref={MyRef}
                key={item.id}
                heading={item.heading}
                data={item.data}
                description={item.description}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
